export default class DefaultHeader {
  private header: HTMLCollectionOf<Element> = document.getElementsByTagName('header')
  private main: HTMLCollectionOf<Element> = document.getElementsByTagName('main')
  constructor(background: string) {
    this.header[0].classList.add(`header-${background}`);
    this.main[0].classList.add(`main-${background}`);

    window.addEventListener('scroll', (ev): void => {
      window.scrollY > 1
        ? this.editMenu('menu-decrease', 'menu-increase')
        : this.editMenu('menu-increase', 'menu-decrease')
    });
  }

  private editMenu(newClass: string, oldClass: string) {
    this.header[0].classList.add(newClass);
    this.header[0].classList.remove(oldClass);
  }
}